import { Component, Input, OnChanges, Optional } from "@angular/core";
import { DataTableDirective, PageEvent } from "./data-table.directive";

@Component({
	selector: "app-paginator",
	template: "<ng-content></ng-content>",
	standalone: false
})
export class PaginatorComponent implements OnChanges {
	private _mfTable: DataTableDirective;

	@Input() mfTable: DataTableDirective;

	activePage: number;
	rowsOnPage: number;
	dataLength: number;
	lastPage: number;

	constructor(@Optional() private injectMfTable: DataTableDirective) {
		this.dataLength = injectMfTable?.mfTableLength || 0;
	}

	ngOnChanges(/* changes: { [key: string]: SimpleChange } */): any {
		this._mfTable = this.mfTable || this.injectMfTable;
		this.onPageChangeSubscriber(this._mfTable.getPage());
		this._mfTable.onPageChange.subscribe(this.onPageChangeSubscriber);
	}

	setPage(pageNumber: number): void {
		this._mfTable.setPage(pageNumber, this.rowsOnPage);
	}

	setRowsOnPage(event: Event): void {
		this._mfTable.setPage(this.activePage, parseInt((event.target as HTMLSelectElement).value));
	}

	private onPageChangeSubscriber = (event: PageEvent) => {
		this.activePage = event.activePage;
		this.rowsOnPage = event.rowsOnPage;
		this.dataLength = event.dataLength;
		this.lastPage = Math.ceil(this.dataLength / this.rowsOnPage);
	};
}